import React from 'react';
import { Stack, Text, Icon } from '@fluentui/react';
import { pageNotFoundStyles } from './pageNotFoundStyles';

interface PageNotFoundProps {
    title?: string;
    message?: string;
    iconName?: string;
}

export function PageNotFound({ title, message, iconName }: PageNotFoundProps): React.ReactElement {
    return (
        <Stack horizontalAlign="center" verticalAlign="center" tokens={{ childrenGap: 25 }}>
            <Icon iconName={iconName} />
            <Text variant="xxLarge" className={pageNotFoundStyles.title}>
                {title}
            </Text>
            <Text variant="large" className={pageNotFoundStyles.message}>
                {message}
            </Text>
        </Stack>
    );
}
